var d = Object.defineProperty;
var c = (p, e, a) => e in p ? d(p, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : p[e] = a;
var t = (p, e, a) => (c(p, typeof e != "symbol" ? e + "" : e, a), a);
class o {
  constructor() {
    // 添加这一行以允许动态属性访问
    t(this, "plateType", "封板");
    t(this, "productLength", 0);
    t(this, "productWidth", 0);
    t(this, "productThickness", 0);
    t(this, "edgeType", "");
    t(this, "num", 1);
  }
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/banjianForm.js
// module id = 1202
// module chunks = 41